/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CoreProcessorModeEnum } from './coreProcessorModeEnum';


export interface SubscriptionRegeneratePostSpec { 
    mode: CoreProcessorModeEnum;
    org_ids?: Array<string>;
    serial_numbers?: Array<string>;
}
export namespace SubscriptionRegeneratePostSpec {
}


